export enum FeedSource {
  EL_MUNDO = "EL_MUNDO",
  EL_PAIS = "EL_PAIS",
  CMS = "CMS",
}
